'use strict';
/**
 * File includes the ajax call to upload file, submit the VIP sign up form,
 * create the mapping for industry and specialty fields
 */
var clientSideValidation = require('../components/clientSideValidation');
var formValidation = require('../components/formValidation');
var breakpoints = require('../components/breakpoints');
var $corporateTerms;
var $industry;
var $licenseInputLabel;
var $professionalTerms;
var $selectOptions;
var $specialty;
var eventmanagementArr;
var industryToSpecialtyMapping;
var isFoundIn;
var mediaArr;
var otherArr;
var professionalArr;
var replaceSpecialtyOptions;
var uploadFiles;
var fileOperationSuccessCallback;
var removeFileSuccessCallback;

/**
 * These variables have been defined and used to handle Industry to Specialty mapping on VIP Sign Up Page
 */
professionalArr = ['fishing', 'golf', 'hunting', 'sports', 'trail', 'travel', 'winter', 'water'];

eventmanagementArr = ['fishing', 'golf', 'hunting', 'music', 'sports', 'trail', 'travel', 'winter', 'water'];

mediaArr = ['digital', 'film', 'radio', 'print', 'television'];

otherArr = ['active military', 'bureau of land management', 'conservation', 'emergency responder/volunteer', 'fbi/law enforcement', 'global relief', 'national park service', 'national ski patrol', 'national wildlife refuge', 'outdoor education', 'us department of agriculture', 'agriculture', 'us forest service', 'us geological survey'];

industryToSpecialtyMapping = {
    nonprofit: otherArr,
    government: otherArr,
    education: otherArr,
    professional: professionalArr,
    eventmanagement: eventmanagementArr,
    media: mediaArr
};

$licenseInputLabel = $('.license-input').prev('label').find('span');

$professionalTerms = $('.terms-professional');

$corporateTerms = $('.terms-corporate');

$specialty = $('.specialty-select');

$selectOptions = $specialty.find('.select-option');

$industry = $('.industry-select');

isFoundIn = function (term, array) {
    return array.indexOf(term) !== -1;
};

/**
 * This function is used to trigger mutation observer to enable submit button on successful UPS verification.
 */
function enableSubmitButton() {
    var $button = $('form.vipsignup .js-btn-registration');
    $button.addClass('ups-address-verified');
}

/**
 * This function is used to trigger mutation observer to disable submit button.
 */
function disableSubmitButton() {
    var $button = $('form.vipsignup .js-btn-registration');
    $button.removeClass('ups-address-verified');
}

/**
 * The professional and corporate terms are shown on the basis of the industry
 * selected from the industry dropdown.
 */
$industry.change(function () {
    var specialtiesToShow;
    var v = this.value;
    if (v === 'nonprofit' || v === 'government' || v === 'education') {
        $licenseInputLabel.text('Federal Tax ID');
        $professionalTerms.hide();
        $corporateTerms.show();
    } else {
        $licenseInputLabel.text('Professional License Number or Station Call Letters, if applicable');
        $professionalTerms.show();
        $corporateTerms.hide();
    }
    specialtiesToShow = industryToSpecialtyMapping[v];
    replaceSpecialtyOptions(specialtiesToShow);
});

/**
 * On the VIP Sign Up Page, the values in the specialty dropdown will be
 * populated on the basis of the value selected in the industry dropdown
 *  @param {string} specToShow - The specialty definitions
 */
replaceSpecialtyOptions = function (specToShow) {
    var optionsToHide;
    var optionsToShow;
    var createFinalDisplay;
    var specialtiesToShow = specToShow;
    if (specialtiesToShow === null || specialtiesToShow === undefined) {
        specialtiesToShow = [];
    }
    optionsToShow = [];
    optionsToHide = [];
    $selectOptions.each(function (i, option) {
        if ((isFoundIn(option.value, specialtiesToShow)) || (option.value.length === 0)) {
            createFinalDisplay = optionsToShow.push(option);
        } else {
            createFinalDisplay = optionsToHide.push(option);
        }
        return createFinalDisplay;
    });
    $.each(optionsToHide, function (i, option) {
        return $(option).detach();
    });
    $.each(optionsToShow, function (i, option) {
        return $specialty.append(option);
    });
};
$industry.trigger('change');

/**
 * Function to update the upload file section on the successfully uploading the file
 * @param {Object} response - Response after successful ajax call
 */
fileOperationSuccessCallback = function (response) {
    var $fileUploadContainer;
    if ((response != null) && response !== '') {
        if (typeof $fileUploadContainer === 'undefined' || $fileUploadContainer === null) {
            if (response.fileuploadError && response.errorMessage) {
                $fileUploadContainer = $('.propurchase-upoload-files-error');
                $fileUploadContainer.html(response.errorMessage);
                $fileUploadContainer.removeClass('d-none');
            } else {
                $fileUploadContainer = $('#propurchase-signup-files-container');
                $fileUploadContainer.html(response);
            }
        }
    }
};

/**
 * Function to update the file remove section on successful file removal
 * @param {Object} response - Response after successful ajax call
 */
removeFileSuccessCallback = function (response) {
    if (response != null && response !== '') {
        var res = $.parseJSON(response);
        var removeFilesContainer = $('#propurchase-remove-files-container');
        // File name element
        if (res.fileUUID != null && removeFilesContainer.find('span[id=' + res.fileUUID + ']')) {
            removeFilesContainer.find('span[id=' + res.fileUUID + ']').remove();
        }
        // Remove button element
        if (res.fileUUID != null && removeFilesContainer.find('button[name=' + res.fileUUID + ']')) {
            removeFilesContainer.find('button[name=' + res.fileUUID + ']').remove();
        }
    }
};

/**
 * Ajax call to upload the files
 * @param {Object} event - current event that contains the file name and the file to be uploaded
 */
uploadFiles = function (event) {
    var $fileUploadWrapper;
    var action;
    var data;
    $fileUploadWrapper = $('#propurchase-signup-files');
    action = $fileUploadWrapper.data('action');
    data = new FormData();
    data.append(event.target.name, event.target.files[0]);
    data.format = 'ajax';
    $.spinner().start();
    $.ajax({
        url: action,
        data: data,
        type: 'POST',
        cache: false,
        processData: false,
        contentType: false,
        success: fileOperationSuccessCallback,
        complete: function () {
            $.spinner().stop();
        }
    });
};

/**
 * Ajax call to remove the file
 * @param {string} action - action url of file to be removed
 */
var removeFile = function (action) {
    $.spinner().start();
    $.ajax({
        dataType: 'html',
        url: action,
        type: 'GET',
        success: removeFileSuccessCallback,
        complete: function () {
            $.spinner().stop();
        }
    });
};


/**
 * On click of the upload file button, a function call to upload the files is made
 * The file name is also added to the page.
 */
$('body').on('change', '.file-chooser-input', function (e) {
    // The whole file path is passed, these two lines split the file path off and keep only the file name.
    var fileNameArray = e.target.value.split('\\');
    var fileName = fileNameArray[fileNameArray.length - 1];
    if (fileName.length > 0 && fileName.indexOf(' ') > 0) {
        $('.propurchase-upoload-files-error').removeClass('d-none');
    } else {
        $('.filename').text(fileNameArray[fileNameArray.length - 1]);
        $('.file-remove-link').removeClass('d-none');
        $('.propurchase-upoload-files-error').addClass('d-none');
        return uploadFiles(e);
    }
    return false;
}).on('click', '.file-chooser', function (e) {
    e.preventDefault();
    return $('.file-chooser-input').click();
}).on('click', '.file-remove-link', function (e) {
    var action = e.target.getAttribute('data-action');
    return removeFile(action);
});

/**
 * function vertically re-align columns
 */
function updateBlockOrder() {
    var positionBlock = function ($element, position) {
        $element.attr('style', 'position:relative; top:-' + position + 'px;');
    };

    var $target = $('.vip-row-container > .order-md-4');
    var $anchorPoint = $('.vip-row-container > .order-md-1');
    var $anchorLastChild = $anchorPoint.children().last();

    var relativePos = $anchorPoint.height() - ($anchorLastChild[0].offsetHeight + $anchorLastChild[0].offsetTop + 16);

    if (breakpoints.isCurrentBreakpoint('lg', 'xl')) {
        positionBlock($target, relativePos);
    } else {
        positionBlock($target, 0);
    }
}

/**
 * On click of the create account from toggle, the content on left section should change
 */
$('.vip-row-container .nav-link-vipsignup').on('click', function () {
    $('.vip-row-container .tab-content .vipsignup').addClass('active');
    $('.vip-row-container .tab-content .vipsignin').removeClass('active');
});

/**
 * On click of the login from toggle, the content on left section should change
 */
$('.vip-row-container .nav-link-vipsignin').on('click', function () {
    $('.vip-row-container .tab-content .vipsignup').removeClass('active');
    $('.vip-row-container .tab-content .vipsignin').addClass('active');
});

/**
 * Listener for Apply Now Button
 */
function changeForm() {
    $('.js-apply-now__button').on('click', function () {
        $('.js-apply-now__form--container').removeClass('d-none');
        $('.js-apply-now__button--container, .vip-signup-title, .vip-customer-service-container').addClass('d-none');

        var $login = $('.vip-login-container');
        $login.removeClass('col-md-6 order-md-2');
        $login.addClass('col-md-3 order-md-3');

        var $apply = $('.vip-apply-container');
        $apply.removeClass('order-md-5');
        $apply.addClass('order-md-2');

        var $loginButton = $('.vip-login-button-container');
        $loginButton.removeClass('col-lg-5');

        updateBlockOrder();
    });
}

// ProPurchase MODULE
var proPurchase = (function () {
    var upsVerifyAddrURL = $('input[name="upsVerifyAddress"]');
    var upsFindCityStateURL = $('input[name="upsFindCityState"]');
    var invalidEmailMsg = $('input[name="invalidEmail"]');
    var upsAddresses = [];

    // Update form fields based on user input
    var addressSelectionEvent = function () {
        $('input[name="address"]').on('click', () => {
            $('.vipsignup-form-ups-address .suggest').remove();
            var selectedAddr = $('input[name="address"]:checked').val();
            if (selectedAddr && upsAddresses && upsAddresses.length > 0) {
                let spc = selectedAddr.split(',')[1];
                var selectedUPSAddress = {};
                if (spc) {
                    let stateCode = spc.split(' ')[1];
                    let postalCode = spc.split(' ')[2];
                    for (var i = 0; i < upsAddresses.length; i++) {
                        selectedUPSAddress = (upsAddresses[i].region === stateCode && upsAddresses[i].postalCode === postalCode) ? upsAddresses[i] : {};
                        if (selectedUPSAddress && selectedUPSAddress.postalCode) {
                            $('input[name$="_profile_address_postalCode"]').val(selectedUPSAddress.postalCode);
                            $('select[id="vipsignup-form-country"]').val(selectedUPSAddress.countryCode);
                            $('input[name$="_profile_address_address1"]').val(selectedUPSAddress.address1);
                            $('input[name$="_profile_address_city"]').val(selectedUPSAddress.municipality);
                            $('select[name$="_profile_address_states_stateCode"]').val(selectedUPSAddress.region);
                            break;
                        }
                    }
                }
            }
            enableSubmitButton();
        });
    };

    /**
     * Gets the required profile form fields
     * @returns {Object} Profile form values
     */
    var getRequiredProfileFormValues = function () {
        return {
            postalCode: $('input[name$="_profile_address_postalCode"]').val(),
            countryCode: $('select[id="vipsignup-form-country"]').val(),
            address1: $('input[name$="_profile_address_address1"]').val(),
            municipality: $('input[name$="_profile_address_city"]').val(),
            region: $('select[name$="_profile_address_states_stateCode"]').val()
        };
    };

    /**
     * Welds the segregated pieces of address fields
     * @param {Object} address - User entered or UPS recommended
     * @returns {Object} Address fields welded into a single address
     */
    var weldAddressFields = function (address) {
        return address.address1 + ' ' +
            address.municipality + ', ' +
            address.region + ' ' +
            address.postalCode;
    };

    /**
     * Show recommendation for UPS addresses to the user
     * @param {Object} addresses - UPS addresses
     */
    var showRecommendations = function (addresses) {
        upsAddresses = addresses;
        var rowDivEle = {};
        var colDivEle = {};
        var inputEle = {};
        var labelEle = {};
        $('.vipsignup-form-ups-address div').remove();
        for (let i = 0; i <= addresses.length; i++) {
            let $upsAddress;
            let $useEnteredAddress = '';
            let reachedLimit = false;
            if (i === 3 || i === addresses.length) {
                $useEnteredAddress = $('input[name="useEnteredAddress"]').val();
                let enteredAddress = getRequiredProfileFormValues();
                $upsAddress = weldAddressFields(enteredAddress);
                upsAddresses.push(enteredAddress);
                reachedLimit = true;
            }
            rowDivEle = document.createElement('div');
            $(rowDivEle).addClass('row mt-2 mb-2');
            colDivEle = document.createElement('div');
            $(colDivEle).addClass('form-check material-radio custom-control custom-radio col-4 pl-4 ml-3 mr-lg-4 col-lg-auto');
            $upsAddress = reachedLimit ? $upsAddress : weldAddressFields(addresses[i]);
            inputEle = document.createElement('input');
            $(inputEle).addClass('custom-control-input');
            inputEle.type = 'radio';
            inputEle.name = 'address';
            inputEle.required = true;
            let elementId = reachedLimit ? addresses.length : addresses[i].id;
            inputEle.id = 'vipsignup-form-ups-address-' + elementId;
            inputEle.value = $upsAddress;
            labelEle = document.createElement('label');
            $(labelEle).addClass('custom-control-label form-check-label');
            labelEle.innerText = reachedLimit ? $useEnteredAddress : $upsAddress;
            $(labelEle).prop('for', 'vipsignup-form-ups-address-' + elementId);
            colDivEle.appendChild(inputEle);
            colDivEle.appendChild(labelEle);
            rowDivEle.appendChild(colDivEle);
            $('.vipsignup-form-ups-address').append(rowDivEle);
            if (reachedLimit) { break; }
        }
        addressSelectionEvent();
        disableSubmitButton();
        $('.ups-verify-addr .vipsignup-form-ups-address').removeClass('d-none');
        $('html, body').animate({
            scrollTop: $('form.vipsignup .vipsignup-form-ups-address').offset().top - 100
        }, 1000);
    };

    /**
     * Find UPS address by city or state to show address recommendations
     * @param {Object} form - ProPurchase form
     */
    var findCityState = function () {
        $.spinner().start();
        $.ajax({
            url: upsFindCityStateURL[0].value,
            type: 'GET',
            data: getRequiredProfileFormValues(),
            success: function (response) {
                if (response.addresses && response.addresses.length > 0) {
                    showRecommendations(response.addresses);
                } else {
                    enableSubmitButton();
                }
                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
                $.spinner().stop();
            }
        });
    };

    /**
     * Validates UPS address before submitting request to register user
     * @param {Object} form - ProPurchase form
     */
    var validateAddress = function () {
        $.spinner().start();
        $.ajax({
            url: upsVerifyAddrURL[0].value,
            type: 'GET',
            data: getRequiredProfileFormValues(),
            success: function (response) {
                if (!response.exactMatch) {
                    if (response.addresses && response.addresses.length === 0) {
                        proPurchase.findCityState();
                    } else {
                        showRecommendations(response.addresses);
                    }
                } else {
                    enableSubmitButton();
                }
                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
                $.spinner().stop();
            }
        });
    };
    /**
     * Validates email address
     */
    var vipFormValidation = function () {
        $('.vipsignup #registration-form-email').siblings('.invalid-feedback').html(invalidEmailMsg[0].value);
        $('.vipsignup #registration-form-email').parent().addClass('is-invalid');
    };

    /**
     * Ajax call on propurchase form submission
     * @param {Object} form - ProPurchase form
     */
    var apply = function (form) {
        $.spinner().start();
        $.ajax({
            url: form.attr('action'),
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                if (!data.success) {
                    formValidation(form, data);
                    $('html, body').animate({
                        scrollTop: $('form.vipsignup .is-invalid').first().offset().top - 100
                    }, 1000);
                    if ($('select[id="vipsignup-form-country"]').val() === 'US') {
                        vipFormValidation();
                    }
                    $.spinner().stop();
                } else {
                    if (typeof _satellite !== 'undefined') {
                        // Cloning digitalData so the event has the state at the moment it was fired
                        // eslint-disable-next-line no-undef
                        _satellite.track('formComplete', { digitalData: window.digitalData ? JSON.parse(JSON.stringify(window.digitalData)) : undefined });
                    }
                    window.location.href = data.redirectUrl;
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
                $.spinner().stop();
            }
        });
    };

    // Public API
    return {
        validateAddress: validateAddress,
        findCityState: findCityState,
        apply: apply
    };
}());

$(document).ready(function () {
    updateBlockOrder();

    $(window).on('resize', updateBlockOrder);
});

/**
 * This function is to watch the submit button state.
 * As per busniss requirement the button will be disabled until the UPS address verification is successful.
 * The button will be only enabled if the UPS address is verified or user accepts the suggested address.
 */
function setSubmitButtonState() {
    var $form = $('form.vipsignup');
    var $button = $('form.vipsignup .js-btn-registration');
    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            var attributeValue = $(mutation.target).prop(mutation.attributeName);
            if (attributeValue.indexOf('ups-address-verified') > -1 && clientSideValidation.functions.quietValidation($form)) {
                $button.removeClass('disabled').prop('disabled', false);
            } else {
                $button.addClass('disabled').prop('disabled', true);
            }
        });
    });

    observer.observe($button[0], {
        attributes: true,
        attributeFilter: ['class']
    });
}

/**
 * This function is to enable/disable Terms and Condition check box.
 * As per busniss requirement the checkbox will be disabled until user enters address in all mandatory fields.
 * The checkbox will be only enabled if all address fields are filled with correct data.
 */
var isAcceptTermsCheckboxEnabled = function () {
    var $currentform = $('form.vipsignup');
    var $acceptTerms = $('form.vipsignup #acceptTerms');
    var toValidate = 'input[name$="_profile_address_postalCode"], select[id="vipsignup-form-country"], input[name$="_profile_address_address1"], input[name$="_profile_address_city"], select[name$="_profile_address_states_stateCode"]';

    /**
    * Checks if the address fields are valid.
    * If so, it enables the accept terms checkbox
    */
    function enableAcceptTermsIfAddressValid() {
        var $toValidate = $currentform.find(toValidate);
        var addressFieldsAreValid = true;

        for (var i = 0; i < $toValidate.length; i++) { // Using for instead of each so we can break
            if ($toValidate[i].validity.valid === false) {
                addressFieldsAreValid = false;
                break;
            }
        }

        if (addressFieldsAreValid) {
            $acceptTerms.removeAttr('disabled');
        } else {
            $acceptTerms.prop('checked', false).attr('disabled', true);
            disableSubmitButton();
        }
    }

    /**
    * Handle situations where the address fields are populated automatically by the server
    * and could already be valid.
    */
    $(enableAcceptTermsIfAddressValid);

    $('body form.vipsignup').on('keyup blur change', toValidate, enableAcceptTermsIfAddressValid);

    // This will triger UPS address validation
    $acceptTerms.change(function () {
        var isChecked = $(this).is(':checked');

        if (isChecked) {
            proPurchase.validateAddress();
        } else {
            disableSubmitButton();
        }
    });
};

module.exports = {
    register: function () {
        $('form.vipsignup').submit(function (e) {
            var $form = $(this);
            e.preventDefault();
            if ($('form.vipsignup').hasClass('ups-verify-addr')
                && $('select[id="vipsignup-form-country"]').val() === 'US') {
                let count = $('input[name="address"]').length > 0 ? $('input[name="address"]:checked').length : undefined;
                switch (count) {
                    case 1:
                        proPurchase.apply($form);
                        break;
                    case 0: {
                        $('.vipsignup-form-ups-address .suggest').remove();
                        let $lastEleId = $('input[name="address"]').last()[0].id;
                        let lastEleParent = $('#' + $lastEleId).parent().parent();
                        let rowDivEle = document.createElement('div');
                        $(rowDivEle).addClass('row mt-2 mb-2 suggest');
                        let spanEle = document.createElement('span');
                        spanEle.innerText = $('input[name="usesuggestedaddress"]').val();
                        rowDivEle.appendChild(spanEle);
                        $(rowDivEle).insertAfter($(lastEleParent));
                        break;
                    }
                    default:
                        proPurchase.apply($form);
                        break;
                }
            } else {
                proPurchase.apply($form);
            }
            return false;
        });
    },
    buttonToForm: changeForm,
    isAcceptTermsCheckboxEnabled: isAcceptTermsCheckboxEnabled,
    setSubmitButtonState: setSubmitButtonState
};
